module.exports = __webpack_public_path__ + "static/media/warning.1be59075.svg";